import { Link } from 'react-router';

import { buttonVariants } from '~/local/components/button';
import { cn } from '~/styling';
import { imgUrl } from '~/urls';

export const Section = ({
  heading,
  text,
  image,
  cta,
}: {
  heading: string;
  text: string;
  image: string;
  cta: { to: string; text: string };
}) => {
  return (
    <div className="flex flex-col gap-y-12 p-2 sm:p-6">
      <div className="md:h-[428px] lg:h-[632px]">
        <img
          className="h-full w-full rounded-2xl object-cover"
          src={imgUrl(image, { width: 500 })}
          alt={heading}
        />
      </div>
      <div className="">
        <h3 className="font-heading-condensed text-2xl font-medium leading-7 tracking-tight text-primary-2-80">
          {heading}
        </h3>
        <p className="mt-4 text-base leading-5 tracking-tight">{text}</p>
        <Link
          to={cta.to}
          className={cn(
            buttonVariants({ intent: 'secondary' }),
            'text-wide mt-6 block w-full text-sm font-medium uppercase leading-3 text-primary-2-80'
          )}
        >
          {cta.text}
        </Link>
      </div>
    </div>
  );
};
